import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, ViewChild, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import { I18NEXT_SERVICE } from 'angular-i18next';
import jsPDF from 'jspdf';
import * as i1 from '@angular/common';

const documentViewerElements = [
    'ColorPickerModal',
    'Model3DModal',
    'OpenFileModal',
    'PageNumberPanel',
    'PageNumberPanelButton',
    'UNKNOWN',
    'URLPanel',
    'URLPanelButton',
    'WarningModalSignButton',
    'accessibility',
    'addNewScale',
    'applyWatermark',
    'bn-option',
    'calibrate',
    'checkStampToolButton',
    'closeErrorModalButton',
    'closeModalButton',
    'colorPalette',
    'contextMenuPopup',
    'continuousPageTransitionButton',
    'copyTextButton',
    'coverLayoutButton',
    'createScale',
    'crossStampToolButton',
    'cs-option',
    'customDisplayScaleUnit',
    'customDisplayScaleValue',
    'customPageScaleUnit',
    'customPageScaleValue',
    'customScaleOption',
    'dateFreeTextToolButton',
    'de-option',
    'defaultPageTransitionButton',
    'deletePage',
    'documentContainer',
    'dotStampToolButton',
    'doubleLayoutButton',
    'downloadButton',
    'downloadDocButton',
    'dropdown-item-0.0001',
    'dropdown-item-0.001',
    'dropdown-item-0.01',
    'dropdown-item-0.1',
    'dropdown-item-La Belle Aurore',
    'dropdown-item-Nothing You Could Do',
    'dropdown-item-Satisfy',
    'dropdown-item-Whisper',
    'dropdown-item-apng',
    'dropdown-item-avif',
    'dropdown-item-bmp',
    'dropdown-item-cm',
    'dropdown-item-cm',
    'dropdown-item-doc',
    'dropdown-item-docx',
    'dropdown-item-ft',
    'dropdown-item-ft-in',
    'dropdown-item-gif',
    'dropdown-item-in',
    'dropdown-item-in',
    'dropdown-item-jfif',
    'dropdown-item-jpeg',
    'dropdown-item-jpg',
    'dropdown-item-km',
    'dropdown-item-m',
    'dropdown-item-md',
    'dropdown-item-mi',
    'dropdown-item-mm',
    'dropdown-item-mm',
    'dropdown-item-pdf',
    'dropdown-item-png',
    'dropdown-item-ppt',
    'dropdown-item-pptx',
    'dropdown-item-pt',
    'dropdown-item-pt',
    'dropdown-item-toolbarGroup-Annotate',
    'dropdown-item-toolbarGroup-Edit',
    'dropdown-item-toolbarGroup-FillAndSign',
    'dropdown-item-toolbarGroup-Forms',
    'dropdown-item-toolbarGroup-Insert',
    'dropdown-item-toolbarGroup-Shapes',
    'dropdown-item-toolbarGroup-View',
    'dropdown-item-webp',
    'dropdown-item-xls',
    'dropdown-item-xlsx',
    'dropdown-item-xod',
    'dropdown-item-yd',
    'el-option',
    'en-option',
    'eraserToolButton',
    'errorModal',
    'errorModalCloseButton',
    'es-option',
    'extractPage',
    'filePickerPanel',
    'filePickerPanelButton',
    'filterModal',
    'formFieldEditPopup',
    'formFieldIndicatorContainer',
    'fr-option',
    'freeHandHighlightToolButton',
    'freeHandToolButton',
    'freeTextToolButton',
    'freeTextToolGroupButton',
    'fullscreenButton',
    'header',
    'hi-option',
    'highlightToolButton',
    'hu-option',
    'id-option',
    'imageSignaturePanel',
    'imageSignaturePanelButton',
    'inkSignaturePanel',
    'inkSignaturePanelButton',
    'insertPageAbove',
    'insertPageBelow',
    'it-option',
    'ja-option',
    'ko-option',
    'languageButton',
    'languageModal',
    'layoutHeader',
    'leftPanel',
    'leftPanelButton',
    'leftPanelResizeBar',
    'leftPanelTabs',
    'linkButton',
    'linkModal',
    'linkSubmitButton',
    'loadingModal',
    'markInsertTextToolButton',
    'markReplaceTextToolButton',
    'menuButton',
    'menuOverlay',
    'modalMarkRedactButton',
    'modalRedactButton',
    'moreButton',
    'moveToBottom',
    'moveToTop',
    'ms-option',
    'multiTabsEmptyPage',
    'nl-option',
    'notesPanelResizeBar',
    'outlinesPanelButton',
    'pageAdditionalControlsHeader',
    'pageInsertionHeader',
    'pageManipulationHeader',
    'pageManipulationOverlay',
    'pageRedactionModal',
    'pageRotationHeader',
    'pageTransitionHeader',
    'panToolButton',
    'passwordModal',
    'passwordSubmitButton',
    'pl-option',
    'presetScaleOption',
    'printButton',
    'printDocButton',
    'printModal',
    'printModalCloseButton',
    'progressModal',
    'pt_br-option',
    'redactionPanelResizeBar',
    'redoButton',
    'replacePage',
    'ribbons',
    'ribbonsDropdown',
    'richTextBoldButton',
    'richTextFormats',
    'richTextItalicButton',
    'richTextPopup',
    'richTextStrikeButton',
    'richTextUnderlineButton',
    'ro-option',
    'rotateClockwiseButton',
    'rotateCounterClockwiseButton',
    'rotateHeader',
    'rotatePageClockwise',
    'rotatePageCounterClockwise',
    'ru-option',
    'rubberStampToolGroupButton',
    'scaleModal',
    'scaleOverlayContainer',
    'scalePrecisions',
    'searchButton',
    'searchPanel',
    'searchPanelResizeBar',
    'selectToolButton',
    'signatureModal',
    'signatureModalCloseButton',
    'signaturePanelButton',
    'signatureToolGroupButton',
    'signatureValidationModal',
    'singleLayoutButton',
    'stickyToolButton',
    'sv-option',
    'text-signature-font-dropdown',
    'textEditingPanelResizeBar',
    'textHighlightToolButton',
    'textPopup',
    'textSelectButton',
    'textSignaturePanel',
    'textSignaturePanelButton',
    'textSquigglyToolButton',
    'textStrikeoutToolButton',
    'textUnderlineToolButton',
    'th-option',
    'themeChangeButton',
    'thumbnailsControlInsertPopup',
    'thumbnailsControlManipulatePopup',
    'thumbnailsControlManipulatePopupSmall',
    'thumbnailsControlRotatePopup',
    'thumbnailsPanelButton',
    'toggleCompareModeButton',
    'toggleNotesButton',
    'toolbarGroup-Annotate',
    'toolbarGroup-Edit',
    'toolbarGroup-FillAndSign',
    'toolbarGroup-Forms',
    'toolbarGroup-Insert',
    'toolbarGroup-Shapes',
    'toolbarGroup-View',
    'toolsHeader',
    'toolsOverlay',
    'tr-option',
    'uk-option',
    'undoButton',
    'updateScale',
    'urlInputPanel',
    'urlInputPanelButton',
    'vi-option',
    'viewControlsButton',
    'viewControlsDivider1',
    'viewControlsDivider2',
    'viewControlsOverlay',
    'wv3dPropertiesPanelResizeBar',
    'zh_cn-option',
    'zh_tw-option',
    'zoomInButton',
    'zoomOutButton',
    'zoomOverlay',
    'zoomOverlay',
    'zoomOverlayButton',
];
const defaultElements = [
    'header',
    'menuButton',
    'menuOverlay',
    'fullscreenButton',
    'themeChangeButton',
    'languageButton',
    'viewControlsButton',
    'downloadDocButton',
    'printDocButton',
    'searchButton',
    'searchPanel',
    'selectToolButton',
    'textSelectButton',
    'panToolButton',
    'zoomOverlayButton',
    'zoomOverlay',
    'zoomOutButton',
    'zoomInButton',
    'viewControlsButton',
    'viewControlsOverlay',
    'pageTransitionHeader',
    'continuousPageTransitionButton',
    'defaultPageTransitionButton',
    'viewControlsDivider1',
    'layoutHeader',
    'singleLayoutButton',
    'doubleLayoutButton',
    'coverLayoutButton',
    'languageModal',
    'en-option',
    'cs-option',
    'el-option',
    'de-option',
    'es-option',
    'fr-option',
    'hu-option',
    'it-option',
    'ja-option',
    'ko-option',
    'nl-option',
    'pt_br-option',
    'pl-option',
    'uk-option',
    'ru-option',
    'ro-option',
    'sv-option',
    'tr-option',
    'th-option',
    'vi-option',
    'id-option',
    'ms-option',
    'hi-option',
    'bn-option',
    'zh_cn-option',
    'zh_tw-option',
];

class FadvDocumentViewerComponent extends FadvBaseComponent {
    constructor(el, i18NextService) {
        super(el);
        this.i18NextService = i18NextService;
        this.documentName = '';
        this.elements = defaultElements;
        this.doc = new jsPDF();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        if (!this.document)
            return;
        // handle .txt separately
        if (this.document instanceof Blob) {
            this.document.type === 'text/plain' ? this.loadTxtFile(this.document) : this.loadWebViewer(this.document);
        }
        else {
            this.loadWebViewer(this.document);
        }
    }
    loadTxtFile(txtBlob) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield txtBlob.text();
            const pageHeight = this.doc.internal.pageSize.height;
            const splitText = this.doc.setFontSize(12).splitTextToSize(result, 180);
            let iterations = 1;
            const margin = 15; // top and bottom margin
            const defaultYJump = 8; // line space
            splitText.forEach((line) => {
                let posY = margin + defaultYJump * iterations++;
                if (posY > pageHeight - margin) {
                    this.doc.addPage();
                    iterations = 1;
                    posY = margin + defaultYJump * iterations++;
                }
                this.doc.text(line, 15, posY);
            });
            // replace extension to .pdf
            const pos = this.documentName.lastIndexOf('.');
            this.documentName = ((_a = this.documentName) === null || _a === void 0 ? void 0 : _a.substring(0, pos < 0 ? this.documentName.length : pos)) + '.pdf';
            this.loadWebViewer(this.doc.output('blob'));
        });
    }
    loadWebViewer(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const instance = yield WebViewer({
                // licenseKey: 'AddYourLicenseKeyHere',
                path: '/assets/webviewer-lib',
                loadAsPDF: true,
                fullAPI: true,
                accessibleMode: true,
                disabledElements: documentViewerElements.filter((item) => !this.elements.includes(item)),
                css: '/assets/styles/fadv-document-viewer.css',
            }, this.viewerRef.nativeElement);
            const { UI } = instance;
            const downloadLabel = this.i18NextService.t('components:documentViewer.download');
            const printLabel = this.i18NextService.t('components:documentViewer.print');
            const headerItemsToAdd = [
                {
                    dataElement: 'printDocButton',
                    type: 'actionButton',
                    img: 'icon-header-print-line',
                    title: printLabel,
                    ariaLabel: printLabel,
                    onClick: () => UI.printInBackground(),
                },
                {
                    dataElement: 'downloadDocButton',
                    type: 'actionButton',
                    img: 'icon-header-download',
                    title: downloadLabel,
                    ariaLabel: downloadLabel,
                    onClick: () => this.downloadDocument(file),
                },
            ];
            this.addLanguageAttribute(instance);
            this.addHeaderItems(instance, headerItemsToAdd);
            this.addIFrameTitle(instance);
            UI.enableHighContrastMode();
            UI.loadDocument(file, { filename: this.documentName });
        });
    }
    downloadDocument(file) {
        const link = document.createElement('a');
        link.href = this.document instanceof Blob ? URL.createObjectURL(file) : file;
        link.download = this.documentName;
        link.click();
    }
    addHeaderItems(instance, items) {
        instance.UI.setHeaderItems((header) => {
            items.forEach((item) => header.push(item));
        });
    }
    addLanguageAttribute(instance) {
        const { UI } = instance;
        const UIEvents = UI.Events;
        const iframeDoc = UI.iframeWindow.document;
        const htmlElement = iframeDoc.querySelector('html');
        if (!htmlElement)
            return;
        htmlElement.lang = 'en';
        UI.addEventListener(UIEvents.LANGUAGE_CHANGED, (e) => {
            const { next } = e.detail;
            htmlElement.lang = next;
        });
    }
    addIFrameTitle(instance) {
        const { documentViewer } = instance.Core;
        const { iframeWindow } = instance.UI;
        const iframeElement = iframeWindow.frameElement;
        const iframeWindowDoc = iframeWindow.document;
        if (iframeElement)
            iframeElement.title = this.i18NextService.t('components:documentViewer.iFrameTitle', { documentName: this.documentName });
        documentViewer.addEventListener('documentLoaded', () => {
            const iframe = iframeWindowDoc.documentElement.querySelector('iframe');
            if (iframe)
                iframe.title = 'iframe';
        }, { once: true });
    }
}
FadvDocumentViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDocumentViewerComponent, deps: [{ token: ElementRef }, { token: I18NEXT_SERVICE }], target: i0.ɵɵFactoryTarget.Component });
FadvDocumentViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvDocumentViewerComponent, selector: "fadv-document-viewer", inputs: { document: "document", documentName: "documentName", elements: "elements" }, viewQueries: [{ propertyName: "viewerRef", first: true, predicate: ["viewer"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<fadv-box p=\"small\" *ngIf=\"document\">\n  <div #viewer class=\"document-viewer\"></div>\n</fadv-box>\n", styles: [".document-viewer{width:100%;height:100vh}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDocumentViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fadv-document-viewer', template: "<fadv-box p=\"small\" *ngIf=\"document\">\n  <div #viewer class=\"document-viewer\"></div>\n</fadv-box>\n", styles: [".document-viewer{width:100%;height:100vh}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [I18NEXT_SERVICE]
                    }] }];
    }, propDecorators: { viewerRef: [{
                type: ViewChild,
                args: ['viewer']
            }], document: [{
                type: Input
            }], documentName: [{
                type: Input
            }], elements: [{
                type: Input
            }] } });

class FadvDocumentViewerModule {
}
FadvDocumentViewerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDocumentViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvDocumentViewerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvDocumentViewerModule, declarations: [FadvDocumentViewerComponent], imports: [FadvCommonModule], exports: [FadvDocumentViewerComponent] });
FadvDocumentViewerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDocumentViewerModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDocumentViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvDocumentViewerComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvDocumentViewerComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvDocumentViewerComponent, FadvDocumentViewerModule, defaultElements, documentViewerElements };
